// src/api/reportsApi.js
import axios from "axios";

const API_BASE_URL = "https://ims.holdthechild.net/api"; // Adjust the base URL as needed

export const getOverview = async () => {
  const res = await axios.get(`${API_BASE_URL}/overview`);
  return res.data;
};

export const getTracking = async () => {
  const res = await axios.get(`${API_BASE_URL}/tracking`);
  return res.data;
};

export const getRecent = async () => {
  const res = await axios.get(`${API_BASE_URL}/recent`);
  return res.data;
};

export const getIndividualReports = async (page = 1) => {
  const res = await axios.get(`${API_BASE_URL}/individual?page=${page}`);
  return res.data;
};
